import Reveal from '../components/Reveal';
import { FacebookIcon, InstagramIcon, PhoneIcon } from '../components/icons';
import './Contact.css';

const MAP_SRC =
  'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2153.143916000455!2d25.61894167731879!3d57.33952796867478!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46ebdc7b941dd0f9%3A0x9df621b1c4cea05e!2sAizrozes%2C%20Aizrozes%2C%20Raunas%20pagasts%2C%20Smiltenes%20novads%2C%20LV-4131!5e0!3m2!1sen!2slv!4v1786023016657!5m2!1sen!2slv';

export default function Contact() {
  return (
    <section id="kontakti" className="section contact">
      <div className="container contact__inner">
        <Reveal className="contact__info">
          <p className="eyebrow">Kontakti</p>
          <h2 className="section-title">Sazināties</h2>

          <a className="contact__phone" href="tel:+37126465017">
            <PhoneIcon />
            26 465 017
          </a>

          <div className="contact__socials">
            <a
              className="contact__social"
              href="https://www.facebook.com/WELLSIMCENTRSCESIS"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FacebookIcon />
              <span>Facebook</span>
            </a>
            <a
              className="contact__social"
              href="https://www.instagram.com/aiva_parandjuka/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <InstagramIcon />
              <span>Instagram</span>
            </a>
          </div>
        </Reveal>

        <Reveal className="contact__map">
          <iframe
            title="Salons Siluets — Aizrozes, Raunas pagasts, Smiltenes novads"
            src={MAP_SRC}
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </Reveal>
      </div>
    </section>
  );
}
